import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import Lottie from "react-lottie-player";
import { AlertTriangle } from 'lucide-react';
import NotFoundAnimation from "@/assets/animations/notfoundAnimation.json";
class AppErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        // Log error to console and potentially to an error tracking service
        console.error('Application Error:', {
            error,
            componentStack: errorInfo.componentStack
        });
        this.setState({
            error,
            errorInfo
        });
    }
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { className: "fixed inset-0 flex flex-col items-center justify-center bg-white p-6", children: _jsxs("div", { className: "max-w-md w-full text-center flex flex-col items-center ", children: [_jsx(Lottie, { animationData: NotFoundAnimation, loop: true, play: true, className: "max-w-[300px] mx-auto mb-5" }), _jsx(AlertTriangle, { size: 28, className: "text-amber-500" }), _jsx("div", { className: "flex items-center justify-center space-x-2 mb-4", children: _jsx("h1", { className: "text-2xl text-gray-800 font-bold font-heading", children: "Creative Workspace is Temporarily Unavailable" }) })] }) }));
        }
        return this.props.children;
    }
}
export default AppErrorBoundary;
